/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const gcpRegions = [
  "africa-south1", // Johannesburg

  "asia-east1", // Taiwan
  "asia-east2", // Hong Kong
  "asia-northeast1", // Tokyo
  "asia-northeast2", // Osaka
  "asia-northeast3", // Seoul
  "asia-south1", // Mumbai
  "asia-south2", // Delhi
  "asia-southeast1", // Singapore
  "asia-southeast2", // Jakarta

  "australia-southeast1", // Sydney
  "australia-southeast2", // Melbourne

  "europe-central2", // Warsaw
  "europe-north1", // Finland
  "europe-west1", // Belgium
  "europe-west2", // London
  "europe-west3", // Frankfurt
  "europe-west4", // Netherlands
  "europe-west6", // Zurich
  "europe-west8", // Milan
  "europe-west9", // Paris

  "me-central1", // Doha
  "me-central2", // Dammam
  "me-west1", // Tel Aviv

  "northamerica-northeast1", // Montreal
  "northamerica-northeast2", // Toronto
  "northamerica-south1", // Queretaro
  "southamerica-east1", // São Paulo
  "southamerica-west1", // Santiago

  "us-central1", // Iowa
  "us-east1", // South Carolina
  "us-east4", // Northern Virginia
  "us-east5", // Columbus
  "us-south1", // Dallas
  "us-west1", // Oregon
  "us-west2", // Los Angeles
  "us-west3", // Salt Lake City
  "us-west4", // Las Vegas
];

export const gcpRegionsOptions = gcpRegions.map((region: string) => ({
  value: region,
  label: region,
}));
